import script from "./ProProxyUiTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProProxyUiTable.vue?vue&type=script&setup=true&lang=js"

import "./ProProxyUiTable.vue?vue&type=style&index=0&id=822ffc58&scoped=true&lang=css"
import "./ProProxyUiTable.vue?vue&type=style&index=1&id=822ffc58&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-822ffc58"]])

export default __exports__